"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const cuandoAplica = ["El equipo siente que hay algo que arreglar pero no hay consenso de por dónde empezar.", "Hay una propuesta interna o externa de implementación y quieres validar antes de comprometer presupuesto.", "Las cotizaciones de proveedores no se pueden comparar entre sí porque cada uno propone alcance distinto.", "El negocio creció y los procesos que funcionaban hace dos años ya no escalan."];
export default function CuandoAplicaDiagnostico() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="diagnostico-cuando-aplica" id="cuando-aplica" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-8">
            Cuándo aplica.
          </h2>

          <p className="font-sans text-lg text-muted-foreground leading-relaxed mb-10 max-w-2xl">
            El Diagnóstico es el servicio correcto cuando una de estas afirmaciones es cierta:
          </p>

          <ul className="space-y-5 mb-10 max-w-2xl">
            {cuandoAplica.map((item, i) => <li key={i} className="flex gap-4 font-sans text-base md:text-lg text-foreground/90 leading-relaxed">
                <span className="font-mono text-primary text-sm mt-1.5 shrink-0">
                  ·
                </span>
                <span>{item}</span>
              </li>)}
          </ul>

          <p className="font-sans text-base md:text-lg italic text-muted-foreground leading-relaxed max-w-2xl">Si nada de esto aplica y ya sabes exactamente qué construir, probablemente lo que necesitas es Partner directo.</p>
        </div>
      </div>
    </section>;
}